import { call, put, select } from 'redux-saga/effects';

import { IMeetingTemplate } from './meeting-templates.types';
import * as actions from './meeting-templates.actions';
import { apiRequest } from '../../api/api.saga-services';
import * as api from '../../api/request-config/meeting-templates.api';
import { meetingTemplatesSelectors } from './meeting-templates.selectors';

export function* fetchMeetingTemplates() {
  const meetingTemplates: IMeetingTemplate[] = yield call(apiRequest, api.getMeetingTemplatesApi());
  if (!meetingTemplates) {
    return;
  }

  yield put(actions.storeMeetingTemplate(meetingTemplates));
  return meetingTemplates;
}

export function* storeMeetingTemplate(meetingTemplate: IMeetingTemplate) {
  yield put(actions.storeMeetingTemplate(meetingTemplate));
  return meetingTemplate;
}

export function* clearMeetingTemplate(meetingTemplateId: IMeetingTemplate['id']) {
  yield put(actions.clearMeetingTemplate(meetingTemplateId));
}

export function* clearAllMeetingTemplates() {
  const meetingTemplateIds: IMeetingTemplate['id'][] = yield select(meetingTemplatesSelectors.selectResourceIds);
  yield put(actions.clearMeetingTemplate(meetingTemplateIds));
}
